import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/home';

export default function LatestUpdates() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm md:text-base">实时同步各大平台最新内容</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestUpdates.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group flex gap-4 p-3 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="w-32 sm:w-40 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-[3/2] object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-center">
                <span className="text-xs text-primary-600 font-medium mb-1">{item.category}</span>
                <h3 className="font-medium text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mb-1">{item.episode}</p>
                <p className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-time-line"></i> {item.updateTime}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}